'use strict';

var _baguetteBox = require('./baguetteBox');

var _baguetteBox2 = _interopRequireDefault(_baguetteBox);

var _sections = require('./sections');

var _sections2 = _interopRequireDefault(_sections);

var _breakpointImageLoader = require('./breakpointImageLoader');

var _breakpointImageLoader2 = _interopRequireDefault(_breakpointImageLoader);

var _multiStory = require('./multiStory');

var _multiStory2 = _interopRequireDefault(_multiStory);

var _storyLightBox = require('./storyLightBox');

var _storyLightBox2 = _interopRequireDefault(_storyLightBox);

var _gallerySwitcher = require('./gallerySwitcher');

var _gallerySwitcher2 = _interopRequireDefault(_gallerySwitcher);

var _main = require('./main');

var _main2 = _interopRequireDefault(_main);

var _navigation = require('./navigation');

var _navigation2 = _interopRequireDefault(_navigation);

var _youTubeTracking = require('./youTubeTracking');

var _youTubeTracking2 = _interopRequireDefault(_youTubeTracking);

var _analyticsPage = require('./analyticsPage');

var _analyticsPage2 = _interopRequireDefault(_analyticsPage);

var _advertisingStyles = require('./advertisingStyles');

var _advertisingStyles2 = _interopRequireDefault(_advertisingStyles);

var _initPrices = require('./initPrices');

var _initPrices2 = _interopRequireDefault(_initPrices);

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var rpBreakpoints = _interopRequireWildcard(_rpMqBreakpoints);

var _rpRaceDayLive = require('rp-race-day-live');

var _rpCookie = require('rp-cookie');

var _rpGuiGuide = require('rp-gui-guide');

var rpGuiGuide = _interopRequireWildcard(_rpGuiGuide);

var _rpPopup = require('rp-popup');

var _rpPopup2 = _interopRequireDefault(_rpPopup);

var _rpAdvertising = require('rp-advertising');

var _rpAdvertising2 = _interopRequireDefault(_rpAdvertising);

var _rpUrlNavigationPrefs = require('rp-url-navigation-prefs');

var _rpUrlNavigationPrefs2 = _interopRequireDefault(_rpUrlNavigationPrefs);

var _rpBettingSpecialOffer = require('rp-betting-special-offer');

var _rpBettingSpecialOffer2 = _interopRequireDefault(_rpBettingSpecialOffer);

var _ScribbleWidgetInteracter = require('./scribble/ScribbleWidgetInteracter');

var _ScribbleWidgetInteracter2 = _interopRequireDefault(_ScribbleWidgetInteracter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { render as renderRdl } from 'rp-race-day-live';
function isMobileDevice() {
    return (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
}
// var PaidIcon from './paidIcon';


$(window).on('load', function () {
    /**
     * Clean-up legacy cookies
     */
    (0, _rpCookie.cleanLegacy)();
    /**
     * Initialize gui-guide scripts
     */
    rpGuiGuide.default({ svg: { polyfill: true } });
    /**
     * Initialize popup component
     */
    (0, _rpPopup2.default)();
    /**
     * Initialize advertising component
     */
    (0, _rpAdvertising2.default)();
    /**
     * Fire the analytics.page() event with the needed traits
     */
    (0, _analyticsPage2.default)();
    /**
     * Initialize betting special offer component
     */
    (0, _rpBettingSpecialOffer2.default)();
    /**
     * Initializing Cookie Policy
     */
    var navigation = new _navigation2.default();
    /**
     * Initialize Youtube tracking
     */
    (0, _youTubeTracking2.default)();

    window.rp1 = window.rp1 || {};
    window.rp1.assetsUrl = window.rp1.assetsUrl || ($('body').data('assetsUrl') !== '' ? $('body').data('assetsUrl') : '');
    (0, _rpUrlNavigationPrefs2.default)();

    // Paid icon hiding to logged premium users (NEWS-2051)
    /**
     * 2010-10-06: Feature temporary disabled according to Jira ticket below
     * @link https://racingpost.atlassian.net/browse/NEWS-2154
     */
    // new PaidIcon($, authReady);

    /**
     * Init Scribble Live Blog interacter
     * @link https://racingpost.atlassian.net/browse/QW-681
     */
    if ($('.scrbbl-embed').length > 0) {
        var scribbleWidgetInteracter = new _ScribbleWidgetInteracter2.default();
        scribbleWidgetInteracter.init();
    }

    // Race Day Live JS Component
    if ($('#rdl-content').length > 0) {
        var curMeeting = window.location.hash.replace('#', '').replace('meet', '');
        if (curMeeting !== '' && $('#rdl-filter-template > option[data-filter = ' + curMeeting + ']').length > 0) {
            $('#rdl-filter-template').val($('#rdl-filter-template > option[data-filter = ' + curMeeting + ']').val());
        }

        $('#rdl-filter-template').rpSelect();
        $('#rdl-filter-template').on('change', function (event, element) {
            var courseId = element.data('filter');
            if (typeof courseId !== 'undefined') {
                courseId = String(courseId);
            }
            $(window.document).trigger('filter.apply', [courseId]);
            if (!window.location.hash) {
                window.history.pushState("", document.title, window.location.pathname + window.location.search);
            }
        });

        (0, _initPrices2.default)();

        var fakeDiffusion = $.cookie('fakeDiffusion') === '1';
        var RDL = new _rpRaceDayLive.RaceDayLive();

        if (fakeDiffusion) {
            RDL.config.headerSpinner.hide();
            window.rp1.fake = {};
            window.rp1.fake.rdl = RDL;
        } else {
            RDL.init();
        }

        // renderRdl(document.getElementById('rdl-content'));
    }

    // Index Page
    if ($('.content').data('index') !== undefined && $('.content').data('url') !== undefined) {
        var section = (0, _sections2.default)($, _breakpointImageLoader2.default);
        section.showMoreDisplay(_main2.default);
        section.startHashClickHandle('a[data-js-class="menu-anchor"]');
        navigation.handleBreakpointChange('More');
        (0, _advertisingStyles2.default)();
    }

    // MultiTab Page
    if ($('#js-multiStoryTabs').length > 0) {
        if (window.location.hash.length && window.location.hash.substr(0, 5) === '#tab-') {
            var tab = parseInt(window.location.hash.substr(5));
            var i = (isNaN(tab) ? 1 : tab) - 1;
            (0, _multiStory2.default)($('ul.tabs').find('a.tabs__link').get(i));
        }
        $('ul.tabs').find('a.tabs__link').click(function () {
            return (0, _multiStory2.default)(this);
        });
    }

    // Story Page
    if ($('.story').length > 0) {
        var lightboxes = [],
            currentBpMaxValue = rpBreakpoints.default.current().max,
            narrowToMediumMediaValue = 719;

        var initLightboxes = function initLightboxes() {
            lightboxes[0] = new _storyLightBox2.default($, _baguetteBox2.default, $('.js-main-gallery').attr('id'));
            $('.js-body-gallery').each(function () {
                lightboxes[lightboxes.length] = new _storyLightBox2.default($, _baguetteBox2.default, $(this)[0].id);
            });
        };

        var overLayHandler = function overLayHandler(visibility) {
            if (visibility) {
                $('#baguetteBox-overlay').show();
            } else {
                $('#baguetteBox-overlay').hide();
            }
        };

        /*
         * This part of code fix bug with incorrect displaying lightbox when user change breakpoints
         * On exNarrow and Narrow baguetteBox-top-overlay element hidden(id changed to baguetteBox-top-overlay-hidden)
         * On Medium and above breakpoints baguetteBox-top-overlay is visible
         */
        var baguetteBoxTreatment = function baguetteBoxTreatment(breakPointValue) {
            var visibleOverlayClass = 'baguetteBox-top-overlay',
                hiddenOverlayClass = 'baguetteBox-top-overlay-hidden',
                visibleOverlaySelector = '#baguetteBox-top-overlay',
                hiddenOverlaySelector = '#baguetteBox-top-overlay-hidden',
                slideShowBylineAndImageSelector = '.slideShow__byline, .js-imageLoader',
                baguetteBoxOverlaySelector = '#baguetteBox-overlay',
                currentBreakPoint = breakPointValue || rpBreakpoints.default.current().max,
                storyGalleryImage = '.storyGallery__item__image',
                icoSelectorList = '.js-gallerySwitchIco-List',
                icoActiveClass = 'gallerySwitch__link-active',
                gallerySelector = '.js-main-gallery',
                galleryClassThumbs = 'storyGallery-tiles',
                galleryClassList = 'storyGallery-list';

            if (currentBreakPoint > narrowToMediumMediaValue) {
                if (!lightboxes.length) {
                    initLightboxes();
                }

                $(hiddenOverlaySelector).removeClass('visible').attr('style', '').attr('id', visibleOverlayClass);
                $(slideShowBylineAndImageSelector).on('click', function () {
                    overLayHandler(true);
                });
                $(baguetteBoxOverlaySelector).show();
            } else {
                $(baguetteBoxOverlaySelector).hide();
                $(visibleOverlaySelector).attr('id', hiddenOverlayClass).hide();
                $(slideShowBylineAndImageSelector).on('click', function () {
                    overLayHandler(false);
                });

                $(icoSelectorList).addClass(icoActiveClass).siblings().removeClass(icoActiveClass);
                $(gallerySelector).removeClass(galleryClassThumbs).addClass(galleryClassList);
            }
        };

        initLightboxes();
        baguetteBoxTreatment();

        $(window).on('rpBreakpointsSwitch', function (event) {
            baguetteBoxTreatment(event.detail.breakpoint.max);
        });

        if ($('.story .betBlock').length > 0) {
            $('.js-diffusionTopicSettingsRace').attr('data-diffusion-racedate', $('.betBlock:first').data('diffusion-racedate'));
            (0, _initPrices2.default)();
            $.event.trigger('dynamicPricesUpdated.PRICES');
        }

        $('.classToggler').click(function () {
            $(this).parent().toggleClass('active');
            return false;
        });

        // modifying breakpoint behavior for galleryStoryGallery
        var respGallery = new _breakpointImageLoader2.default($('.js-galleryImg'), $);
        respGallery.config = {
            extraNarrow: 'br-n',
            narrow: 'br-n',
            medium: 'br-n',
            wide: 'br-m',
            extraWide: 'br-n'
        };
        respGallery.changeCallback = function (image, nextImg) {
            if (image.children('img').attr('src') !== nextImg) {
                image.children('img').attr('src', nextImg);
            }
        };
        respGallery.BreakPointListener();

        if ($('.js-story-gallery').length > 0) {
            (0, _gallerySwitcher2.default)($, {}, respGallery);
        }

        var responsiveAll = new _breakpointImageLoader2.default($('.js-imageLoader'), $);
        responsiveAll.BreakPointListener();
    }

    // hide sotial icons for non mobile devices
    if (!isMobileDevice()) {
        $('.socialLinks__item--whatsapp').hide();
        $('.socialLinks__item--messenger').hide();
    }
});


//////////////////
// WEBPACK FOOTER
// ./public/js/app.js
// module id = 1508
// module chunks = 0